import inputTypes from "../../../../formComponents/formFields/constants";

const industryOptions = [
  "Accounting",
  "Agriculture",
  "Architecture",
  "Art & Design",
  "Attorney & Law",
  "Automotive",
  "Business & Consulting",
  "Communications",
  "Community & Non-Profit",
  "Construction",
  "Consumer Products",
  "Education",
  "Entertainment",
  "Environmental",
  "Financial Services",
  "Food & Beverage",
  "Games & Recreational",
  "Home Furnishing",
  "Industrial",
  "Internet",
  "Manufacturing",
  "Medical & Pharmaceutical",
  "Political",
  "Real Estate & Mortgage",
  "Retail",
  "Restaurant",
  "Retail",
  "Security",
  "Sports",
  "Technology",
  "Travel & Accommodations",
  "Others",
].map((e) => {
  return { label: e, value: e };
});

const formFields = {
  company_id: {
    default: undefined,
    type: inputTypes.SELECT,
    required: false,
    settings: {
      optionsFetchFrom: {
        url: "/admin/companies/form_selects/companies",
        cacheKey: "adminFormSelectsCompanies",
      },
    },
  },
  organization: {
    default: undefined,
    type: inputTypes.SIMPLE_TEXT,
    required: true,
    label: "Company name",
  },
  anonymous: {
    default: "false",
    type: inputTypes.RADIO,
    required: false,
    options: [
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
  },
  company_description: {
    default: undefined,
    type: inputTypes.SIMPLE_TEXTAREA,
    required: false,
    placeholder: "Enter a description",
  },
  industry: {
    default: undefined,
    type: inputTypes.SELECT,
    required: false,
    options: [...industryOptions],
  },
  logo_pic: {
    default: undefined,
    type: inputTypes.IMAGE_FILE,
    required: false,
    acceptExtensions: ["png", "jpg", "jpeg"],
  },
  team_name: {
    default: undefined,
    type: inputTypes.SIMPLE_TEXT,
    required: true,
    label: "Team name",
  },
  default_challenger_type: {
    default: undefined,
    type: inputTypes.SELECT,
    required: false,
    options: [
      {
        label: "Innovation",
        value: "innovation",
      },
      {
        label: "Ideation",
        value: "ideation",
      },
    ],
  },
  default_challenger_role: {
    default: undefined,
    type: inputTypes.SELECT,
    required: false,
    options: [
      {
        label: "Administrator",
        value: "administrator",
      },
      {
        label: "Reviewer",
        value: "reviewer",
      },
      {
        label: "Viewer",
        value: "viewer",
      },
    ],
  },
};

const inputsConfigWithNames = Object.fromEntries(
  Object.entries(formFields).map(([fKey, fVal]) => [
    fKey,
    { name: fKey, ...fVal },
  ]),
);

export default inputsConfigWithNames;
